// Messages for portal/Account — the signed-in user's profile, security &
// notification preferences (auto-merged into the i18n catalog by lib/i18n.ts).
//
// `portal.notif_event.*` are the **customer-facing** labels for catalog events on
// the notification-preferences list. The catalog's own descriptions
// (EventType.description) are written in operator voice ("A quote was sent to the
// customer"); on the portal we relabel them from the customer's point of view
// ("You received a new quote"). Account.tsx maps each event's key → this label,
// falling back to the server description for any event without one.
export const en = {
  'portal.account.head': 'Account — Portal',
  'portal.account.title': 'Account',
  'portal.account.desc': 'Your profile, security & notification preferences',
  'portal.account.profile': 'Profile',
  'portal.account.security': 'Security',
  'portal.account.two_factor': 'Two-factor authentication',
  'portal.account.on': 'On',
  'portal.account.set_up': 'Set up',
  'portal.account.sign_in_method': 'Sign-in method',
  'portal.account.magic_password': 'Magic link · Password',
  'portal.account.active_sessions': 'Active sessions',
  'portal.account.device_one': '{count} device',
  'portal.account.device_other': '{count} devices',
  'portal.account.magic_notice': 'Magic-link sign-in is enabled by Geo4Logistics for this account.',
  'portal.account.notifications': 'Notification preferences',
  'portal.account.notifications_desc':
    "Turn email on or off for each update. When it's on, we email you as it happens; the in-app inbox always updates live.",

  // Customer-facing event labels (second person, "your"). Only the curated
  // customer catalog (EventType.customer_visible) needs a label — see
  // db/seeds/reference/03_event_types.rb.
  'portal.notif_event.shipment.created': 'A shipment was booked for you',
  'portal.notif_event.shipment.updated': 'A message about your shipment',
  'portal.notif_event.shipment.status_changed': 'Your shipment status changed',
  'portal.notif_event.quote.sent': 'You received a new quote',
  'portal.notif_event.quote_request.updated': 'An update on your quote request',
  'portal.notif_event.invoice.issued': 'You received a new invoice',
  'portal.notif_event.document.added': 'A new document was shared with you',
  'portal.notif_event.document.exported': 'A PDF you requested is ready to download',
  'portal.notif_event.message.created': 'You received a new message',
  'portal.notif_event.message.mentioned': 'You were mentioned in a message',
  'portal.notif_event.announcement.published': 'A new announcement from Geo4Logistics',
}

export const zhTW = {
  'portal.account.head': '帳戶 — 客戶入口',
  'portal.account.title': '帳戶',
  'portal.account.desc': '您的個人檔案、安全性與通知偏好',
  'portal.account.profile': '個人檔案',
  'portal.account.security': '安全性',
  'portal.account.two_factor': '雙重驗證',
  'portal.account.on': '已開啟',
  'portal.account.set_up': '設定',
  'portal.account.sign_in_method': '登入方式',
  'portal.account.magic_password': '魔術連結 · 密碼',
  'portal.account.active_sessions': '使用中的工作階段',
  'portal.account.device_one': '{count} 部裝置',
  'portal.account.device_other': '{count} 部裝置',
  'portal.account.magic_notice': 'Geo4Logistics 已為此帳戶啟用魔術連結登入。',
  'portal.account.notifications': '通知偏好',
  'portal.account.notifications_desc':
    '為每項更新開啟或關閉電子郵件。開啟時，我們會即時通知您；站內收件匣則始終即時更新。',

  // 以客戶視角撰寫的事件標籤（僅涵蓋客戶可見的精選事件目錄）。
  'portal.notif_event.shipment.created': '已為您建立貨件',
  'portal.notif_event.shipment.updated': '關於您貨件的訊息',
  'portal.notif_event.shipment.status_changed': '您的貨件狀態已變更',
  'portal.notif_event.quote.sent': '您收到一份新報價',
  'portal.notif_event.quote_request.updated': '您的報價申請有更新',
  'portal.notif_event.invoice.issued': '您收到一張新發票',
  'portal.notif_event.document.added': '已與您分享新文件',
  'portal.notif_event.document.exported': '您申請的 PDF 已可下載',
  'portal.notif_event.message.created': '您收到一則新訊息',
  'portal.notif_event.message.mentioned': '有人在訊息中提及您',
  'portal.notif_event.announcement.published': 'Geo4Logistics 發布新公告',
}
